/* unplugin-vue-components disabled */import { render } from "./xianyangzhiye.vue?vue&type=template&id=7a84be92&scoped=true"
import script from "./xianyangzhiye.vue?vue&type=script&lang=js"
export * from "./xianyangzhiye.vue?vue&type=script&lang=js"

import "./xianyangzhiye.vue?vue&type=style&index=0&id=7a84be92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a84be92"]])

export default __exports__